import type { IPathBaseParam, IPathByIdParam } from "./path";

import type { IApiResponse, IPagination, IPaginationParams } from "@/api";
import { createGetAllApi } from "@api/util/createGetAllApi";
import { createGetApi } from "@api/util/createGetApi";
import type { INotificationResponse } from "@api/notifications/types";

const getAllApis = createGetAllApi<
  IApiResponse<IPagination<INotificationResponse>>,
  IPathBaseParam,
  IPaginationParams
>("notifications.sent");
const getApis = createGetApi<
  IApiResponse<INotificationResponse>,
  IPathByIdParam,
  object
>("notifications.sent");

export const sent = {
  ...getAllApis,
  ...getApis,
};
